module.exports = __webpack_public_path__ + "img/chess-8348280_1280.ea18e618.jpg";